export default class rmDateTimePicker {
    constructor() {
        return {
            restrict: 'E',
            scope: {
                myDate: '=ngModel',
                toggle: '=',
                weeks: '=',
                min: '=',
                max: '='
            },
            template: require("../../../../views/directives/rm-datetimepicker/rm-datetimepicker.html"),
            controller: RuleCalendarCtrl,
            controllerAs: 'calendar'
        }
    }
}

class RuleCalendarCtrl {
    constructor($scope, $document, $filter) {
        this._scope = $scope;
        this._filter = $filter;

        this._scope.datepickerId = this._scope.$id;

        this._unwatch = this._scope.$watch('myDate', (newVal, oldVal) => {

            if (newVal === oldVal) {
                if (! newVal || newVal.length < 1) {
                    this._scope.myDate = new Date();
                }
            }

            if (this._scope.myDate instanceof Date) {
                this._scope.myDate = $filter('date')(this._scope.myDate, 'yyyy-MM-dd HH:mm:ss');
            }

            this.displayDate = this._filter('date')(new Date(moment(this._scope.myDate || new Date())), 'yyyy-MM-dd HH:mm');
        });

        $document.on('click', (e) => {
            if ($(e.target).hasClass('rule-datepicker-date') || $(e.target).closest('tr').length) {
                return;
            }

            this.togglePicker(null);
        });

        $scope.$on("$destroy", () => {
            this._unwatch();
        });
    }

    togglePicker(id) {
        let datepickers = $('.rule-datepicker');

        if (this._scope.toggle) {
            angular.forEach(datepickers, (datepicker) => {
                if ($(datepicker).hasClass('rule-datepicker-' + id)) {
                    $(datepicker).removeClass('hidden');
                } else {
                    $(datepicker).addClass('hidden');
                }
           })
        }
    }
};
